import { Component, ComponentInterface, h, Element } from '@stencil/core';

import URLS from '../app-root/urls';

@Component({
  tag: 'navigation-product',
  styleUrl: 'style.scss',
  scoped: false,
  shadow: false
})

export class NavigationProduct implements ComponentInterface {
  @Element() private element: HTMLElement;

  /**
   * Set active menu in the middle of viewport
   */
  componentDidLoad() {
    const elems = this.element.querySelector('.link-active');

    if(elems !== null){
      setTimeout(function() {
        elems.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'});
      }, 300);
    }
  }

  render() {
    return (
      <div class='secondary-nav'>
        <ul class='secondary-nav-links'>
          <li>
            <stencil-route-link url={URLS.AppProduct}>
              Czym jest Zento
            </stencil-route-link>
          </li>
          <li>
            <stencil-route-link url={URLS.AppProductDesignPWA}>
              Design &amp; PWA
            </stencil-route-link>
          </li>
          <li>
            <stencil-route-link url={URLS.AppProductMagento2core}>
              Magento 2 Core
            </stencil-route-link>
          </li>
          <li>
            <stencil-route-link url={URLS.AppProductAutomation}>
              Automatyzacja
            </stencil-route-link>
          </li>
          <li>
            <stencil-route-link url={URLS.AppProductProcess}>
              Proces
            </stencil-route-link>
          </li>
          <li>
            <stencil-route-link url={URLS.AppProductHosting}>
              Hosting
            </stencil-route-link>
          </li>
          <li>
            <stencil-route-link url={URLS.AppProductGdprDataGovernanace}>
              RODO &amp; Ochrona danych
            </stencil-route-link>
          </li>
          <li>
            <stencil-route-link url={URLS.AppProductIntegrations}>
              Integracje
            </stencil-route-link>
          </li>
        </ul>
      </div>
    );
  }
}
